module.exports = __webpack_public_path__ + "img/strategy3.55b19be5.jpg";